import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation, useParams, Navigate } from 'react-router-dom';
import { Header } from './layout/Header';
import { Footer } from './layout/Footer';
import { HomePage } from './pages/HomePage';
import { AboutPage } from './pages/AboutPage';
import { ContactPage } from './pages/ContactPage';
import { ServicePage } from './pages/ServicePage';
import { AdminPage } from './pages/AdminPage';

const SERVICE_SLUGS = ['mobelrenovering', 'dukning', 'skyltfonster', 'design'];

// Scrolla till toppen vid sidbyte (om inte en ankarlänk anges).
function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, left: 0 });
  }, [pathname, hash]);
  return null;
}

// Tjänstesida via URL-parameter, t.ex. /tjanst/dukning
function ServiceRoute() {
  const { slug } = useParams();
  if (!SERVICE_SLUGS.includes(slug)) return <Navigate to="/" replace />;
  return <ServicePage slug={slug} />;
}

// Vanlig sajt-layout (header + footer). Admin ligger utanför detta.
function SiteLayout() {
  return (
    <div className="min-h-screen bg-cv-base flex flex-col">
      <Header />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/tjanst/:slug" element={<ServiceRoute />} />
          <Route path="/om" element={<AboutPage />} />
          <Route path="/kontakt" element={<ContactPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/*" element={<SiteLayout />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
